import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Cool thing Thursday: Dream of Pixels",
  "description": "",
  "published": "2012-10-11T00:00:00.000Z",
  "redirect_from": ["/blog/cool-thing-thursday-dream-of-pixels/swizec/5401"],
  "categories": "Games, IOS, Puzzle, Tetris-like, Uncategorized, Video Games",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><em parentName="p">{`Loading ... random logic.`}</em></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/10/dream-of-pixels.png",
        "alt": "Dream of Pixels",
        "title": "Dream of Pixels"
      }}></img></p>
    <p><em parentName="p">{`Images ... misplaced.`}</em></p>
    <p><em parentName="p">{`Numbers ... unidentified.`}</em></p>
    <p><em parentName="p">{`Enter ... erase.`}</em></p>
    <p>{`A few days ago I got my grubby little paws on `}<a parentName="p" {...{
        "href": "http://dawnofplay.com/"
      }}>{`Dawn of Play`}</a>{`'s next iOS game `}<em parentName="p">{`Dream of Pixels`}</em>{`.`}</p>
    <p>{`Dram of Pixels is a simple game, one of those addicting little buggers you play whenever you're waiting for a bus, something to compile or the person you are talking to takes 2.3 seconds too long to respond. Think tetris, but in reverse.`}</p>
    <p>{`Your goal is to clear falling lines of pixels by chopping out the familiar shapes from Tetris. There's also a puzzle level and a nightmare and some things I haven't unlocked yet. Topping it all off is a very nice soundtrack, shiny looks and a sexy female voice saying strange things about random logic.`}</p>
    <p>{`After losing the game lets you share an animated screenshot of the last thing you saw before waking up from the dream.`}</p>
    <p>{`You should pester `}<a parentName="p" {...{
        "href": "https://twitter.com/zigah111"
      }}>{`@zigah111`}</a>{` to give you access to the beta. It's really fun.`}</p>
    <p><img parentName="p" {...{
        "src": "https://img.dawnofplay.com/dop/ss/screenshots/17CB1E74-4D40-4F5F-8973-DE028DB5B207.gif",
        "alt": "I'm not actually very good at this",
        "title": "I'm not actually very good at this"
      }}></img></p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.awesome-robo.com/2012/08/the-beep-eijo.html"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/106625121_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://www.awesome-robo.com/2012/08/the-beep-eijo.html"
        }}>{`The Beep - Eijo`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://stackoverflow.com/questions/12651632/rmagick-pixel-color-value"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/noimg_101_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://stackoverflow.com/questions/12651632/rmagick-pixel-color-value"
        }}>{`rmagick pixel color value`}</a></li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/?px",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=cbc75b19-276c-4d8a-a8cd-896b1f60ba53",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      